<template>
  <b-container>
    <div class="vdist">
      <b-row align-h="between" >
        <b-col cols="auto">
          <b-button @click="goPrev()" :disabled="prev===null" variant="primary"> starsze</b-button>
        </b-col>
        <b-col cols="auto">
          <b-button @click="goNext()" :disabled="next===null" variant="primary" > nowsze</b-button>
        </b-col>
      </b-row>
    </div>

    <div class="vdist">
      <Vote :vote-pair="curr" @voteComplete="voteCompleted" v-if="curr!==null"></Vote>
    </div>

    <div class="vdist" v-if="curr===null">
      Nie masz historii
    </div>
  </b-container>
</template>

<script>

import {api} from '@/utils'
import Vote from "@/components/Vote";

export default {
  name: 'historyPage',
  components: {Vote},
  props: ["axios"],
  data: function () {
    return {
      curr: null,
      prev: null,
      next: null
    }
  },
  created() {
    this.loadVotePairs()
  },
  methods: {

    loadVotePairs() {
      this.axios.get(api(`pairs/history/${this.offset()}/1`))
          .then(resp => {
            if (resp.data.length === 1)
              this.curr = resp.data[0]
          })
      this.axios.get(api(`pairs/history/${this.offset() + 1}/1`))
          .then(resp => {
            if (resp.data.length === 1)
              this.prev = resp.data[0]
          })
      if (this.offset() - 1 >= 0)
        this.axios.get(api(`pairs/history/${this.offset() - 1}/1`))
            .then(resp => {
              if (resp.data.length === 1)
                this.next = resp.data[0]
            })
      else
        this.next = null
    },
    goPrev() {
      this.$router.push({path: `/history/${this.offset() + 1}`})
    },
    goNext() {
      this.$router.push({path: `/history/${this.offset() - 1}`})
    },
    offset() {
      return parseInt(this.$route.params.offset)
    },
    voteCompleted(vp) {
      this.axios.post(api("vote"), vp)
    }

  },
  watch: {
    $route() {
      this.loadVotePairs()
    }
  }

}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>


</style>
